/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoWalletConnectionLogListWalletConnectionLogListData model module.
 * @module model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData
 * @version 1.0
 */
class LogControllerDtoWalletConnectionLogListWalletConnectionLogListData {
    /**
     * Constructs a new <code>LogControllerDtoWalletConnectionLogListWalletConnectionLogListData</code>.
     * @alias module:model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData
     */
    constructor() { 
        
        LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoWalletConnectionLogListWalletConnectionLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData} The populated <code>LogControllerDtoWalletConnectionLogListWalletConnectionLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoWalletConnectionLogListWalletConnectionLogListData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('networkType')) {
                obj['networkType'] = ApiClient.convertToType(data['networkType'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoWalletConnectionLogListWalletConnectionLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoWalletConnectionLogListWalletConnectionLogListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['accountNo'] = undefined;

/**
 * @member {String} walletAddress
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['walletAddress'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['status'] = undefined;

/**
 * @member {Number} networkType
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['networkType'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoWalletConnectionLogListWalletConnectionLogListData.prototype['createdAt'] = undefined;






export default LogControllerDtoWalletConnectionLogListWalletConnectionLogListData;

